export default __webpack_public_path__ + "static/media/logo.68b1feff.webp";